export default "__VITE_ASSET__BAu8GwZq__"